import { Language_EN, Language_ES, Language_FR, Language_IT } from './Configuration'

export interface ArticleDefaultColumn {
  key?: string
  name?: string
  multipleSearch?: boolean
  language?: string
  price?: boolean
  pricelist?: number
  isMarketplace?: boolean
  mktColumn?: string
  isListing?: boolean
  isTypeSell?: number
}

/* Table sorting */
export const TableSortingAscend = 'ascend'
export const TableSortingDescend = 'descend'

/* Table currency */
export const defaultCurrency = 'Euro'
export const DefaultCurrencyExchange = 1

/* Article table dynamic label header mode */
export const initalHeaderMode = 'initial'
export const autocompleteHeaderMode = 'autocomplete'

/*Table columns*/
export enum ArticleColumn {
  TableKey = 'key',
  ArticleCode = 'articleCode',
  FarfetchId = 'idFarfetch',
  Category = 'category',
  SuperCategory = 'superCategory',
  Brand = 'brand',
  Season = 'season',
  CollectionType = 'collectionType',
  Department = 'department',
  Color = 'color',
  Supplier = 'supplier',
  StorageLocation = 'storageLocation',
  ProductDescription = 'productDescription',
  Fabric = 'fabric',
  Size = 'size',
  Lifestyle = 'lifestyle',
  Tag = 'tags',
  Barcode = 'barcode',
  CustomsCode = 'customsCode',
  CountryOrigin = 'countryOrigin',
  DetailedComposition = 'detailedComposition',
  Availability = 'availability',
  Pattern = 'pattern',
  Field1 = 'field1',
  Field2 = 'field2',
  Field3 = 'field3',
  Field4 = 'field4',
  Field5 = 'field5',
  Field6 = 'field6',
  Field7 = 'field7',
  Field8 = 'field8',
  Field9 = 'field9',
  Field10 = 'field10',
  OriginalRetailPrice = 'originalRetailPrice',
  OriginalRetailPricelist1Key = 'priceList1OriginalRetailPrice',
  OriginalRetailPricelist2Key = 'priceList2OriginalRetailPrice',
  RetailPrice = 'retailPrice',
  RetailPricelist1Key = 'priceList1RetailPrice',
  RetailPricelist2Key = 'priceList2RetailPrice',
  DiscountedPrice = 'discountedPrice',
  DiscountedPrice1 = 'discountedPrice1',
  DiscountedPrice2 = 'discountedPrice2',
  DiscountedPricelist1Key = 'priceList1DiscountedPrice',
  Discounted1Pricelist1Key = 'priceList1DiscountedPrice1',
  Discounted2Pricelist1Key = 'priceList1DiscountedPrice2',
  DiscountedPricelist2Key = 'priceList2DiscountedPrice',
  Discounted1Pricelist2Key = 'priceList2DiscountedPrice1',
  Discounted2Pricelist2Key = 'priceList2DiscountedPrice2',
  WholesalePrice = 'wholesalePrice',
  WholesalePricelist1Key = 'priceList1WholesalePrice',
  WholesalePricelist2Key = 'priceList2WholesalePrice',
  GrossWholesalePrice = 'grossWholesalePrice',
  GrossWholesalePricelist1Key = 'priceList1GrossWholesalePrice',
  GrossWholesalePricelist2Key = 'priceList2GrossWholesalePrice',
  ShortDescription = 'descriptionShort',
  SpecialDescription = 'descriptionSpecial',
  Description = 'description',
  SizeAndFit = 'sizeAndFit',
  ShortDescriptionIT = 'descriptionShortIT',
  SpecialDescriptionIT = 'descriptionSpecialIT',
  DescriptionIT = 'descriptionIT',
  SizeAndFitIT = 'sizeAndFitIT',
  ShortDescriptionEN = 'descriptionShortEN',
  SpecialDescriptionEN = 'descriptionSpecialEN',
  DescriptionEN = 'descriptionEN',
  SizeAndFitEN = 'sizeAndFitEN',
  ShortDescriptionES = 'descriptionShortES',
  SpecialDescriptionES = 'descriptionSpecialES',
  DescriptionES = 'descriptionES',
  SizeAndFitES = 'sizeAndFitES',
  ShortDescriptionFR = 'descriptionShortFR',
  SpecialDescriptionFR = 'descriptionSpecialFR',
  DescriptionFR = 'descriptionFR',
  SizeAndFitFR = 'sizeAndFitFR',
  SuperBrand = 'superBrand',
  SubCategory = 'subCategory',
  SuperColor = 'superColor',
  ProductCode = 'productCode',
}

/*Articles col length for table and width calc*/
export const ArticleDefaultColLength = 150
export const ArticleCodeColLength = 254
export const FarfetchIdColLength = 125
export const SeasonColLength = 115
export const CollectionTypeColLength = 150
export const SupplierColLength = 210
export const BrandSuperColLength = 130
export const BrandColLength = 125
export const CategoryColLength = 145
export const SubCategoryColLength = 140
export const SuperCategoryColLength = 145
export const DepartmentColLength = 110
export const ProductDescriptionColLength = 210
export const SuperColorColLength = 150
export const ColorColLength = 125
export const FabricColLength = 210
export const PatternColLength = 125
export const LifestyleColLength = 125
export const SizeColLength = 130
export const StorageLocationColLength = 130
export const BarcodeColLength = 150
export const CountryOriginColLength = 110
export const CustomsCodeColLength = 160
export const DetailedCompositionColLength = 150
export const ExtraShortDescriptionColLength = 175
export const ExtraArticleDescriptionColLength = 200
export const ExtraDescriptionSpecialColLength = 180
export const SizeAndFitColLength = 140
export const OriginalRetailPriceColLength = 130
export const RetailPriceColLength = 110
export const DiscountPriceColLength = 110
export const DiscountPrice1ColLength = 110
export const DiscountPrice2ColLength = 110
export const GrossWholesalePriceColLength = 155
export const WholesalePriceColLength = 115
export const ArticleDefaultPriceColLength = 105
export const ArticleDefaultMarketplaceColLength = 120
export const DefaultFreeWidthMaxLength = 420
export const SizeSpecialColumn = 50
export const SizeWithAvailabilitySpecialColumn = 100

/*------------------------------*/

export const DefaultCols: ArticleDefaultColumn[] = [
  {
    name: ArticleColumn.ArticleCode,
    multipleSearch: true,
  },
  {
    name: ArticleColumn.FarfetchId,
    multipleSearch: true,
  },
  {
    name: ArticleColumn.Season,
    multipleSearch: true,
  },
  {
    name: ArticleColumn.CollectionType,
    multipleSearch: true,
  },
  {
    name: ArticleColumn.Supplier,
    multipleSearch: true,
  },
  {
    name: ArticleColumn.SuperBrand,
    multipleSearch: true,
  },
  {
    name: ArticleColumn.Brand,
    multipleSearch: true,
  },
  {
    name: ArticleColumn.Category,
    multipleSearch: true,
  },
  {
    name: ArticleColumn.SubCategory,
    multipleSearch: true,
  },
  {
    name: ArticleColumn.SuperCategory,
    multipleSearch: true,
  },
  {
    name: ArticleColumn.Department,
    multipleSearch: true,
  },
  {
    name: ArticleColumn.ProductDescription,
  },
  {
    name: ArticleColumn.SuperColor,
    multipleSearch: true,
  },
  {
    name: ArticleColumn.Color,
    multipleSearch: true,
  },
  {
    name: ArticleColumn.Fabric,
    multipleSearch: true,
  },
  {
    name: ArticleColumn.Pattern,
    multipleSearch: true,
  },
  {
    name: ArticleColumn.Lifestyle,
    multipleSearch: true,
  },
  {
    name: ArticleColumn.Size,
  },
  {
    name: ArticleColumn.StorageLocation,
  },
  {
    name: ArticleColumn.Tag,
    multipleSearch: true,
  },
  {
    name: ArticleColumn.Barcode,
  },
  {
    name: ArticleColumn.CountryOrigin,
  },
  {
    name: ArticleColumn.CustomsCode,
  },
  {
    name: ArticleColumn.DetailedComposition,
  },
  {
    name: ArticleColumn.ShortDescription,
    key: ArticleColumn.ShortDescriptionIT,
    language: Language_IT,
  },
  {
    name: ArticleColumn.SpecialDescription,
    key: ArticleColumn.SpecialDescriptionIT,
    language: Language_IT,
  },
  {
    name: ArticleColumn.Description,
    key: ArticleColumn.DescriptionIT,
    language: Language_IT,
  },
  {
    name: ArticleColumn.SizeAndFit,
    key: ArticleColumn.SizeAndFitIT,
    language: Language_IT,
  },
  {
    name: ArticleColumn.ShortDescription,
    key: ArticleColumn.ShortDescriptionEN,
    language: Language_EN,
  },
  {
    name: ArticleColumn.SpecialDescription,
    key: ArticleColumn.SpecialDescriptionEN,
    language: Language_EN,
  },
  {
    name: ArticleColumn.Description,
    key: ArticleColumn.DescriptionEN,
    language: Language_EN,
  },
  {
    name: ArticleColumn.SizeAndFit,
    key: ArticleColumn.SizeAndFitEN,
    language: Language_EN,
  },
  {
    name: ArticleColumn.ShortDescription,
    key: ArticleColumn.ShortDescriptionES,
    language: Language_ES,
  },
  {
    name: ArticleColumn.SpecialDescription,
    key: ArticleColumn.SpecialDescriptionES,
    language: Language_ES,
  },
  {
    name: ArticleColumn.Description,
    key: ArticleColumn.DescriptionES,
    language: Language_ES,
  },
  {
    name: ArticleColumn.SizeAndFit,
    key: ArticleColumn.SizeAndFitES,
    language: Language_ES,
  },
  {
    name: ArticleColumn.ShortDescription,
    key: ArticleColumn.ShortDescriptionFR,
    language: Language_FR,
  },
  {
    name: ArticleColumn.SpecialDescription,
    key: ArticleColumn.SpecialDescriptionFR,
    language: Language_FR,
  },
  {
    name: ArticleColumn.Description,
    key: ArticleColumn.DescriptionFR,
    language: Language_FR,
  },
  {
    name: ArticleColumn.SizeAndFit,
    key: ArticleColumn.SizeAndFitFR,
    language: Language_FR,
  },
  {
    name: ArticleColumn.Field1,
  },
  {
    name: ArticleColumn.Field2,
  },
  {
    name: ArticleColumn.Field3,
  },
  {
    name: ArticleColumn.Field4,
  },
  {
    name: ArticleColumn.Field5,
  },
  {
    name: ArticleColumn.Field6,
  },
  {
    name: ArticleColumn.Field7,
  },
  {
    name: ArticleColumn.Field8,
  },
  {
    name: ArticleColumn.Field9,
  },
  {
    name: ArticleColumn.Field10,
  },
  {
    name: ArticleColumn.OriginalRetailPrice,
    key: ArticleColumn.OriginalRetailPricelist1Key,
    price: true,
    pricelist: 1,
  },
  {
    name: ArticleColumn.RetailPrice,
    key: ArticleColumn.RetailPricelist1Key,
    price: true,
    pricelist: 1,
  },
  {
    name: ArticleColumn.DiscountedPrice,
    key: ArticleColumn.DiscountedPricelist1Key,
    price: true,
    pricelist: 1,
  },
  {
    name: ArticleColumn.DiscountedPrice1,
    key: ArticleColumn.Discounted1Pricelist1Key,
    price: true,
    pricelist: 1,
  },
  {
    name: ArticleColumn.DiscountedPrice2,
    key: ArticleColumn.Discounted2Pricelist1Key,
    price: true,
    pricelist: 1,
  },
  {
    name: ArticleColumn.WholesalePrice,
    key: ArticleColumn.WholesalePricelist1Key,
    price: true,
    pricelist: 1,
  },
  {
    name: ArticleColumn.GrossWholesalePrice,
    key: ArticleColumn.GrossWholesalePricelist1Key,
    price: true,
    pricelist: 1,
  },
  {
    name: ArticleColumn.OriginalRetailPrice,
    key: ArticleColumn.OriginalRetailPricelist2Key,
    price: true,
    pricelist: 2,
  },
  {
    name: ArticleColumn.RetailPrice,
    key: ArticleColumn.RetailPricelist2Key,
    price: true,
    pricelist: 2,
  },
  {
    name: ArticleColumn.DiscountedPrice,
    key: ArticleColumn.DiscountedPricelist2Key,
    price: true,
    pricelist: 2,
  },
  {
    name: ArticleColumn.DiscountedPrice1,
    key: ArticleColumn.Discounted1Pricelist2Key,
    price: true,
    pricelist: 2,
  },
  {
    name: ArticleColumn.DiscountedPrice2,
    key: ArticleColumn.Discounted2Pricelist2Key,
    price: true,
    pricelist: 2,
  },
  {
    name: ArticleColumn.WholesalePrice,
    key: ArticleColumn.WholesalePricelist2Key,
    price: true,
    pricelist: 2,
  },
  {
    name: ArticleColumn.GrossWholesalePrice,
    key: ArticleColumn.GrossWholesalePricelist2Key,
    price: true,
    pricelist: 2,
  },
]

export const DefaultAlignedRightColumns = [
  ArticleColumn.GrossWholesalePricelist2Key,
  ArticleColumn.GrossWholesalePricelist1Key,
  ArticleColumn.WholesalePricelist2Key,
  ArticleColumn.WholesalePricelist1Key,
  ArticleColumn.Discounted2Pricelist2Key,
  ArticleColumn.Discounted2Pricelist1Key,
  ArticleColumn.Discounted1Pricelist2Key,
  ArticleColumn.Discounted1Pricelist1Key,
  ArticleColumn.DiscountedPricelist2Key,
  ArticleColumn.DiscountedPricelist1Key,
  ArticleColumn.RetailPricelist2Key,
  ArticleColumn.RetailPricelist1Key,
  ArticleColumn.OriginalRetailPricelist2Key,
  ArticleColumn.OriginalRetailPricelist1Key,
]

export const emptyTableHeight = 151
export const articleRowHeight = 35
export const defaultSingleRowHeight = 37
export const defaultArticlesToShow = 10

const predefinedFilters = [
  { value: ArticleColumn.ArticleCode, active: true, visible: false },
  { value: ArticleColumn.FarfetchId, active: false, visible: false },
  { value: ArticleColumn.Season, active: false, visible: false },
  { value: ArticleColumn.CollectionType, active: false, visible: false },
  { value: ArticleColumn.Supplier, active: true, visible: false },
  { value: ArticleColumn.SuperBrand, active: false, visible: false },
  { value: ArticleColumn.Brand, active: true, visible: false },
  { value: ArticleColumn.Category, active: true, visible: false },
  { value: ArticleColumn.SubCategory, active: false, visible: false },
  { value: ArticleColumn.SuperCategory, active: false, visible: false },
  //micro category (not available yet)
  { value: ArticleColumn.Department, active: true, visible: false },
  { value: ArticleColumn.ProductDescription, active: true, visible: false },
  { value: ArticleColumn.SuperColor, active: false, visible: false },
  { value: ArticleColumn.Color, active: true, visible: false },
  { value: ArticleColumn.Fabric, active: false, visible: false },
  { value: ArticleColumn.Pattern, active: false, visible: false },
  { value: ArticleColumn.Lifestyle, active: false, visible: false },
  { value: ArticleColumn.Size, active: false, visible: false },
  { value: ArticleColumn.StorageLocation, active: false, visible: false },
  { value: ArticleColumn.ProductCode, active: false, visible: false },
  { value: ArticleColumn.Tag, active: false, visible: false },
]

const emptyPredefinedFilters = [
  { value: ArticleColumn.FarfetchId, active: false },
  { value: ArticleColumn.Season, active: false },
  { value: ArticleColumn.CollectionType, active: false },
  { value: ArticleColumn.Supplier, active: false },
  { value: ArticleColumn.SuperBrand, active: false },
  { value: ArticleColumn.Brand, active: false },
  { value: ArticleColumn.Category, active: false },
  { value: ArticleColumn.SubCategory, active: false },
  { value: ArticleColumn.SuperCategory, active: false },
  //micro category (not available yet)
  { value: ArticleColumn.Department, active: false },
  { value: ArticleColumn.ProductDescription, active: false },
  { value: ArticleColumn.SuperColor, active: false },
  { value: ArticleColumn.Color, active: false },
  { value: ArticleColumn.Fabric, active: false },
  { value: ArticleColumn.Pattern, active: false },
  { value: ArticleColumn.Lifestyle, active: false },
  { value: ArticleColumn.StorageLocation, active: false },
]

const extraFilters = [
  //photo type (not available yet)
  { value: ArticleColumn.Barcode, active: false, visible: false },
  { value: ArticleColumn.CountryOrigin, active: false, visible: false },
  { value: ArticleColumn.CustomsCode, active: false, visible: false },
  { value: ArticleColumn.DetailedComposition, active: false, visible: false },
  { value: ArticleColumn.ShortDescription, active: false, visible: false },
  { value: ArticleColumn.SpecialDescription, active: false, visible: false },
  { value: ArticleColumn.Description, active: false, visible: false },
  { value: ArticleColumn.SizeAndFit, active: false, visible: false },
]

const emptyExtraFilters = [
  { value: ArticleColumn.Barcode, active: false },
  { value: ArticleColumn.CountryOrigin, active: false },
  { value: ArticleColumn.CustomsCode, active: false },
  { value: ArticleColumn.DetailedComposition, active: false },
]

const priceFilters = [
  { value: ArticleColumn.OriginalRetailPrice, active: false, visible: false },
  { value: ArticleColumn.RetailPrice, active: true, visible: false },
  { value: ArticleColumn.DiscountedPrice, active: true, visible: false },
  { value: ArticleColumn.DiscountedPrice1, active: false, visible: false },
  { value: ArticleColumn.DiscountedPrice2, active: false, visible: false },
  { value: ArticleColumn.GrossWholesalePrice, active: false, visible: false },
  { value: ArticleColumn.WholesalePrice, active: false, visible: false },
]

const optionalsFilters = [
  { value: ArticleColumn.Field1, active: false, visible: false },
  { value: ArticleColumn.Field2, active: false, visible: false },
  { value: ArticleColumn.Field3, active: false, visible: false },
  { value: ArticleColumn.Field4, active: false, visible: false },
  { value: ArticleColumn.Field5, active: false, visible: false },
  { value: ArticleColumn.Field6, active: false, visible: false },
  { value: ArticleColumn.Field7, active: false, visible: false },
  { value: ArticleColumn.Field8, active: false, visible: false },
  { value: ArticleColumn.Field9, active: false, visible: false },
  { value: ArticleColumn.Field10, active: false, visible: false },
]

const webAndMarketingFilters = []

export const pricelists = {
  priceList1Enabled: false,
  priceList1Visible: false,
  priceList1: '',
  priceList2Enabled: false,
  priceList2Visible: false,
  priceList2: '',
}

export const extraDescriptionLang = { [Language_IT]: [], [Language_EN]: [], [Language_ES]: [], [Language_FR]: [] }

export const defaultTableColumns = {
  predefinedFilters: predefinedFilters,
  extraFilters: extraFilters,
  priceFilters: priceFilters,
  optionalsFilters: optionalsFilters,
  webAndMarketingFilters: webAndMarketingFilters,
}
export const defaultEmptyTableColumns = {
  predefinedFilters: emptyPredefinedFilters,
  extraFilters: emptyExtraFilters,
}

/*Price listing table*/
export enum PriceType {
  purchase = 'ACQ',
  sell = 'VEN',
}
export enum PriceDateRange {
  month = 'MONTH',
  threeMonths = '3MONTHS',
  year = 'YEAR',
  freeDates = 'FREEDATES',
}
export enum PriceTypeShow {
  omni = 'OMNI',
  history = 'HISTORY',
  edit = 'EDIT',
}
export const priceStandardHeight = 484
export const priceStandardRowHeight = 25
export const priceStandardCellDiscountWidth = 45
export const priceStandardCellPriceWidth = 120
export const priceStandardCellPriceStoresWidth = 200

/*Quantity Limit table*/
export const quantityLimitDelayColumn = 'delay'
export const quantityLimitMarketplaceColumn = 'marketplacename'
export const quantityLimitRowNameColumn = 'rowName'
export const quantityLimitOrderedRow = 'ordered'
export const quantityLimitAvailableRow = 'available'

export const quantityLimitDefaultInputChannelName = 'default'

export const quantityLimitDelayColWidth = 100
export const quantityLimitMarketplaceColWidth = 150
export const quantityLimitRowNameColWidth = 100
export const quantityLimitSizesTitleMinWidth = 160

/*Omnichannel*/

export const channelTablePrefix = 'channelTable'
export const channelTableCode = 'code'
export const channelTableStores = 'stores'
export const channelTableName = 'name'
export const channelTableId = 'id'
export const channelTableModifiedDate = 'modifiedDate'
export const channelTablePriceList = 'pricelist'
export const channelTableFixedImport = 'fixedImport'
export const channelTableTransport = 'fixedShipping'
export const channelTableMultiShipping = 'multiShipping'
export const channelTableCommission = 'commission'
export const channelTableCommissionsRange = 'commissions'

export const rangefilterByRange = 'range'
export const rangefilterBySupergroup = 'supergroup'
export const rangefilterBySector = 'sector'

export const shippingTableISO = 'iso'
export const shippingTableCountry = 'name'
export const shippingTableAmount = 'amount'

export const rangeRowFilters = [rangefilterByRange, rangefilterBySector, rangefilterBySupergroup]

export const ChannelTableCols = [
  channelTableName,
  channelTablePriceList,
  channelTableFixedImport,
  channelTableTransport,
  channelTableCommission,
  channelTableCommissionsRange,
  channelTableModifiedDate,
]

export const ShippingTableCols = [shippingTableISO, shippingTableCountry, shippingTableAmount]

export enum SiteColumns {
  Name = 'name',
  Pricelists = 'pricelists',
  //Enabled = 'enabled',
}
export enum StoreColumns {
  Name = 'name',
  Pricelists = 'pricelist',
  SalesStartDate = 'salesStartDate',
  SalesEndDate = 'salesEndDate',
}

const subRulePurchased = 'purchased'
const subRuleStockDays = 'stockDays'
const subRuleSellout = 'sellout'
const subRuleSelloutVal = 'percSellOut'
const subRuleExisting = 'existing'
const subRuleExistingPrice = 'existingPrice'
const subRuleDelivered = 'deliveredPerc'
export const subRuleListingPurchased = 'purchased'
export const subRuleListingDiscount = 'discount'
export const subRuleListingMargin = 'margin'

export const SubRuleColumns = [
  {
    name: ArticleColumn.ArticleCode,
    multipleSearch: true,
  },
  {
    name: ArticleColumn.FarfetchId,
    multipleSearch: true,
  },
  {
    name: ArticleColumn.Season,
    multipleSearch: true,
  },
  {
    name: ArticleColumn.CollectionType,
    multipleSearch: true,
  },
  {
    name: ArticleColumn.Supplier,
    multipleSearch: true,
  },
  {
    name: ArticleColumn.SuperBrand,
    multipleSearch: true,
  },
  {
    name: ArticleColumn.Brand,
    multipleSearch: true,
  },
  {
    name: ArticleColumn.Category,
    multipleSearch: true,
  },
  {
    name: ArticleColumn.SubCategory,
    multipleSearch: true,
  },
  {
    name: ArticleColumn.SuperCategory,
    multipleSearch: true,
  },
  {
    name: ArticleColumn.Department,
    multipleSearch: true,
  },
  {
    name: ArticleColumn.ProductDescription,
  },
  {
    name: ArticleColumn.SuperColor,
    multipleSearch: true,
  },
  {
    name: ArticleColumn.Color,
    multipleSearch: true,
  },
  {
    name: ArticleColumn.Fabric,
    multipleSearch: true,
  },
  {
    name: ArticleColumn.Pattern,
    multipleSearch: true,
  },
  {
    name: ArticleColumn.Lifestyle,
    multipleSearch: true,
  },
  {
    name: ArticleColumn.Size,
  },
  {
    name: ArticleColumn.StorageLocation,
  },
  {
    name: ArticleColumn.Tag,
    multipleSearch: true,
  },
  {
    name: subRulePurchased,
    subRuleLockedColumn: true,
  },
  {
    name: subRuleStockDays,
    subRuleLockedColumn: true,
  },
  {
    name: subRuleSellout,
    subRuleLockedColumn: true,
  },
  {
    name: subRuleSelloutVal,
    subRuleLockedColumn: true,
  },
  {
    name: subRuleExisting,
    subRuleLockedColumn: true,
  },
  {
    name: subRuleExistingPrice,
    subRuleLockedColumn: true,
  },
  {
    name: subRuleDelivered,
    subRuleLockedColumn: true,
  },
]

export const ListingColWidth = 150
export const KpiColWidth = 50
export const columnCloseWidth = 15

export const defaultSubRuleTableColumns = {
  predefinedFilters: predefinedFilters,
}

export const defaultEmptySubRuleTableColumns = {
  predefinedFilters: emptyPredefinedFilters,
}

//Does not include CUSTOM which are not fixed, they have their own custom name
export enum FixedExpenseColumns {
  ADW = 'ADW',
  DOGANA = 'Dogana',
  FISSE = 'Fisse',
  ALTRO = 'Altro',
  PREMI = 'Premi',
  NEW = 'New',
  CHANNEL = 'Channel',
  TOTAL = 'Total',
}
